import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UsersService } from 'src/app/configuration/users/users.service';
import { SalesOrderCreateTransferDialogComponent } from 'src/app/sales/sales-orders/sales-order-create-transfer-dialog/sales-order-create-transfer-dialog.component';
import { ApiService } from 'src/app/services/api.service';
import { FormService } from 'src/app/services/form.service';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';

@Component({
  selector: 'app-prompt-for-default-store-dialog',
  templateUrl: './prompt-for-default-store-dialog.component.html',
  styleUrls: ['./prompt-for-default-store-dialog.component.scss']
})
export class PromptForDefaultStoreDialogComponent implements OnInit {

  // error messages
  fieldErrors: object = {};
  formErrors: any = null;

  // states
  formProcessing: boolean = false;
  loading: boolean = true;
  isSubmitted: boolean = false;

  // form group
  form: UntypedFormGroup = this._fb.group({
    StoreRefId: [null, Validators.required],
  });

  constructor(
    private _fb: UntypedFormBuilder,
    private _formSvc: FormService,
    private _userSvc: UsersService,
    private _apiSvc: ApiService,
    private _toastMsgSvc: ToastMessageService,
    public dialogRef: MatDialogRef<SalesOrderCreateTransferDialogComponent>,
  ) { }

  ngOnInit(): void {
    let storeRefId = this._userSvc.getDefaultStoreId();

    if(storeRefId){
      this.form.controls['StoreRefId'].setValue(storeRefId); 
    }
    this.loading = false;
  }

  onSubmit(e: Event): void {

    e.preventDefault();

    this.isSubmitted = true;

    if (!this.form.valid || this.formProcessing) {
      this._formSvc.scrollToError('.field-invalid');
      return;
    }

    const values = JSON.parse(JSON.stringify(this.form.value));

    this._apiSvc.updatePatch(`${this._apiSvc.endpoints.identity}/api/AuthUser/UpdateDefaultStore`, values.StoreRefId)
      .subscribe((res: any) => {
        this._toastMsgSvc.send({
          type: 'success',
          message: 'Default Store Set',
          icon: 'check_circle_outline'
        });

        this.dialogRef.close({confirm: true, storeRefId: values.StoreRefId, defaultPriceTypeId: res.DefaultPriceTypeId});

        this.formProcessing = false;
      }, (err: any) => {

        const errors = this._formSvc.processFormErrors(err);

        if (errors.formErrors) {
          this.formErrors = errors.formErrors;
        }

        if (errors.fieldErrors) {
          this.fieldErrors = errors.fieldErrors;
        }

        this.formProcessing = false;

        this._formSvc.scrollToError('.field-invalid');

      });
  
  }

}
